import React from "react";
import { Tag, Typography } from "antd";
import { useComputerRefine } from "hook/base/computer/useComputerAction";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const MachineHeader = () => {
  // -------------------------- VAR -----------------------------
  const { total } = useComputerRefine();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <div>
      <Typography.Title style={{ margin: "0px" }} level={4}>
        Quản lý máy chủ ảo{" "}
        <Tag style={{ borderRadius: 30 }}>Total: {total}</Tag>
      </Typography.Title>
      <Typography.Text type="secondary">
        Tất cả máy chủ sẽ được cấu hình và theo dõi trong màn hình này
      </Typography.Text>
    </div>
  );
};
export default MachineHeader;
